module.exports = __webpack_public_path__ + "img/siq-m-222.9d3c52e.png";